import { render, staticRenderFns } from "./UserLoyaltyDetails.vue?vue&type=template&id=3f06c571"
import script from "./UserLoyaltyDetails.vue?vue&type=script&lang=js"
export * from "./UserLoyaltyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports